import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=4147c3c8&scoped=true&"
import script from "./MemberProfile.vue?vue&type=script&lang=js&"
export * from "./MemberProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147c3c8",
  null
  
)

export default component.exports